import { PricingPlanProp } from "./props";

const pricingPlans: PricingPlanProp[] = [
  {
    planName: "Free",
    price: "0€",
    features: [
      {
        featureHeading: "Download",
        featureValues: ["all words"]
      }
    ]
  },
  {
    planName: "Premium",
    price: "9€ one-time",
    features: [
      {
        featureHeading: "Download",
        featureValues: ["all words", "all word translations"]
      },
      {
        featureHeading: "Table Filter",
        featureValues: ["show words column", "show word translations column"]
      }
    ]
  }
];

export default pricingPlans;
